import { z } from "zod";
export const DocumentationPageDependencies = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    documentationPageId: z.string(),
    tokenPersistentIds: z.set(z.string()),
    figmaComponentPersistentIds: z.set(z.string()),
    componentPersistentIds: z.set(z.string()),
    figmaNodePersistentIds: z.set(z.string()),
    groupPersistentIds: z.set(z.string()),
    propertyPersistentIds: z.set(z.string()),
    themePersistentIds: z.set(z.string()),
    documentationPagePersistentIds: z.set(z.string()),
    storybookEntriesStoryIds: z.array(z.string()),
});
